import "./Footer.scss";
import DropDown from "../../../../shared/DropDowns/DropDown";
import {Link} from "react-router-dom";
import {PATHS} from "../../../../routers/utils/Paths.links";
import SocialIcons from "./components/SocialIcons/SocialIcons";
import CustomIcon from "../../../../shared/SvgIcons/CopyIcon";
import {copyText} from "../../../../shared/functions/clickCopyText";
import {getCurrentDateInSeconds} from "../../../../shared/functions/getRandomId";
import {useState} from "react";
import Toaster, {ToasterProps} from "../../../../shared/Toaster/Toaster";
import {useI18n} from "../../../../i18n/I18nProvider";

const Footer = () => {
    const { t } = useI18n();
    const currentYear = new Date().getFullYear();
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);

    const copyTextFunc = async (text: string) => {
        try {
            await copyText(text) // Ждём завершения операции копирования
            setToastProps({
                message: "Дані додані в буфер обміну",
                type: "success",
                id: getCurrentDateInSeconds()
            })
        } catch (error) {
            setToastProps({
                message: "Помилка при копіюванні даних у буфер обміну",
                type: "error",
                id: getCurrentDateInSeconds()
            })
        }
    }

    return (
        <div className="footer-wrapper">
            <div className="d-flex just-content-center">
                <Link style={{paddingRight: "50px"}} className="policy" to={PATHS.AGREEMENT}>
                    {t("footer.agreement")}
                </Link>
                <Link className="policy" to={PATHS.PRIVACY}>
                    {t("footer.privacy")}
                </Link>
                <Link style={{paddingLeft: "50px"}} className="policy" to={PATHS.ABOUT}>
                    {t("footer.about")}
                </Link>
            </div>
            <footer>
                <div className="container-footer">
                    <div className="copyright"><strong>© ASKOLD </strong>{currentYear}.</div>
                    <div className="social-links">
                        <a className="social-link" target="_blank" href="https://discord.gg/GC44JMuAGQ">Discord</a>
                        <a className="social-link" target="_blank" href="https://www.youtube.com/@YoreLua">YouTube</a>
                        <a className="social-link" target="_blank" href="https://www.tiktok.com/@askold.dayz">TikTok</a>
                    </div>
                    <SocialIcons />
                    {/*<DropDown />*/}

                    {/*<div className="d-flex">*/}
                    {/*    <div className="footer-email">Зворотній зв'язок -</div>*/}
                    {/*    <span style={{marginLeft: "5px", fontWeight: "bold"}}>askold69@meta.ua</span>*/}
                    {/*    <button onClick={() => copyTextFunc("askold69@meta.ua")} className="copy-button">*/}
                    {/*        <CustomIcon fill={"var(--foter-color-text)"} />*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
                <DropDown />
            </footer>
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </div>
    );
};

export default Footer;